(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uv-about-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(hero) {
    if (hero.dataset.uvReady) return;
    hero.dataset.uvReady = 'true';
    if (still) return;

    var tiles = Array.prototype.slice.call(hero.querySelectorAll('.uv-tile'));
    var speeds = [-26, -44, -14];   /* each tile drifts at its own pace */
    var inner = [14, -12, 10];      /* image moves inside its tile */
    var badge = hero.querySelector('.uv-badge');
    var ticking = false;

    function update() {
      ticking = false;
      var r = hero.getBoundingClientRect();
      var vh = window.innerHeight;
      if (r.bottom < -100 || r.top > vh + 100) return;
      var off = ((r.top + r.height / 2) - vh / 2) / vh;   /* about -1 to 1 */
      off = Math.max(-1.2, Math.min(1.2, off));

      tiles.forEach(function (t, i) {
        t.style.translate = '0 ' + (off * speeds[i]).toFixed(1) + 'px';
        var img = t.querySelector('img');
        if (img) img.style.translate = '0 ' + (off * inner[i]).toFixed(1) + 'px';
      });
      if (badge) badge.style.translate = '0 ' + (off * -30).toFixed(1) + 'px';
    }

    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function initAll() {
    document.querySelectorAll('.uv-hero').forEach(initHero);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
